module.exports = __webpack_public_path__ + "static/img/c12.e40455e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/c12.png
// module id = WxwK
// module chunks = 0